import {
  SHOW_SNACKBAR,
  HIDE_SNACKBAR,
  SnackbarActions,
  ShowSnackbarType,
  defaultShowSnackbar,
  SHOW_SNACKBAR_ERROR,
  SHOW_SNACKBAR_SUCCESS,
} from './types'

const reducers = (state: any = defaultShowSnackbar, action: SnackbarActions): ShowSnackbarType => {
  switch (action.type) {
    case SHOW_SNACKBAR:
      return {
        visible: true,
        error: false,
        type: 'notification',
        ...action.payload,
      }
    case SHOW_SNACKBAR_ERROR:
      return {
        visible: true,
        icon: null,
        error: true,
        type: 'error',
        ...action.payload,
      }
    case SHOW_SNACKBAR_SUCCESS:
      return {
        visible: true,
        icon: 'icon-light-close-circle',
        error: false,
        type: 'success',
        ...action.payload,
      }
    case HIDE_SNACKBAR:
      return {
        ...state,
        visible: false,
      }
    default:
      return state
  }
}

export default reducers
